import { ALERT, PENDING_QUOTES, UNASSIGNED_QUOTES, URGENT_QUOTES, ONGOING_QUOTES, INCOMPLETE_QUOTES, NEW_QUOTES, DECLINED_QUOTES, COMPLETED_QUOTES, APPROVED_QUOTES, CONCLUDED_QUOTES } from '../constants/actionTypes'
import * as api from '../api'

const getQuotes = async (status, dispatch, setLoading, type, project) => {
    try {
        const { data } = project ? await api.getProjects(status) : await api.getQuotes(status)

        dispatch({ type, payload: data })
        setLoading(false)
    } catch (error) {
        setLoading(false)
        if(error.response) dispatch({ type: ALERT, payload: { severity: 'error', message: error.response.data.message, duration: 5000, display: true }})
        else dispatch({ type: ALERT, payload: { severity: 'error', message: 'An unexpected error occurred', duration: 5000, display: true }})
    }
}

export const getPendingQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, PENDING_QUOTES, false)
}

export const getUnassignedQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, UNASSIGNED_QUOTES, false)
}

export const getUrgentQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, URGENT_QUOTES, false)
}

export const getOngoingQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, ONGOING_QUOTES, false)
}

export const getIncompleteQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, INCOMPLETE_QUOTES, false)
}

export const getDeclinedQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, DECLINED_QUOTES, false)
}

export const getCompletedQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, COMPLETED_QUOTES, false)
}

export const getApprovedQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, APPROVED_QUOTES, false)
}

export const getConcludedQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, CONCLUDED_QUOTES, false)
}

export const getNewQuotes = (status, setLoading) => async (dispatch) => {
    getQuotes(status, dispatch, setLoading, NEW_QUOTES, true)
}